import { h } from 'preact';

// Online/offline presence dot. online: true = green, false = grey, anything
// else renders nothing — unknown presence (hidden profiles, data not loaded)
// must not show a dot at all.
//
// Two placements:
//  - overlay (default): absolutely positioned bottom-right, for use inside a
//    position-relative wrapper around an avatar (see gui/avatar.js)
//  - inline: a small dot that flows with text, for name-only rows (race
//    lists) where there is no avatar to overlay
function PresenceDot({ online, size = 10, inline = false }) {
    if (online !== true && online !== false) {
        return null;
    }
    const color = online ? 'bg-success' : 'bg-secondary';
    const dimension = `width: ${size}px; height: ${size}px;`;
    if (inline) {
        return (
            <span
                class={`d-inline-block rounded-circle flex-shrink-0 ms-1 ${color}`}
                style={dimension}
            />
        );
    }
    return (
        <span
            class={`position-absolute rounded-circle ${color}`}
            style={`${dimension} bottom: 0; right: 0; border: 2px solid var(--bs-body-bg);`}
        />
    );
}

export default PresenceDot;
